import PropTypes from "prop-types";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";

// Usage Guide
/**
 * useAxiosFetchData is a custom React hook that fetches data from a specified URL using axios.
 * @param {Object} params - The parameters for the hook.
 * @param {string} params.url - The absolute URL to fetch data from.
 * @param {('get'|'post')} params.method - The HTTP method to use.
 * @param {Object} [params.body=null] - The body of the request.
 * @param {Object} [params.headers=null] - The headers of the request.
 * @param {boolean} [params.onLoad=true] - A flag indicating whether to fetch the data when the component mounts.
 * @returns {Object} result - The result object.
 * @returns {Object} result.response - The response data from the server.
 * @returns {string} result.error - An error message.
 * @returns {boolean} result.loading - A flag indicating whether the data is currently being fetched.
 */


const useAxiosFetchHeaderData = ({ url, method, body = null, headers = null, onLoad = true }) => {

    // Props Validation
    PropTypes.checkPropTypes({
        url: PropTypes.string.isRequired,
        method: PropTypes.oneOf(['get', 'post']).isRequired,
    }, { url, method }, 'url and method are required in useAxiosFetchData');

    
    const [response, setResponse] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const fetchData = useCallback(async () => {
        // console.log("Fetching User State at time: " + new Date().toLocaleTimeString());
        // console.log("Url: " + url);
        let retVal = null;
        setLoading(true);
        try {
            const res = await axios({
                url: url,
                method: method,
                data: body,
                headers: headers,
                withCredentials: true,

            }).then((res) => {
                if (res.headers['Content-Type'] === 'text/html') {
                    console.log('Received HTML, refetching...');
                    fetchData();
                    
                }
                setResponse(res.data);
                retVal = res;
            }).catch((err) => {
                console.log(err);
                setError(err);
            });

        } catch (err) {
            setError(err);
        }
        setLoading(false);
        return retVal;
    },[body, headers, method, url]);

    useEffect(() => {
        if (onLoad) {
            fetchData({ url, method, body, headers });
        }
    }, [url, method, onLoad, body, headers, fetchData]);
    return { response, error, loading, fetchData };
}
export default useAxiosFetchHeaderData;